import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from "@angular/common";

@Injectable({providedIn: 'root'})
@Pipe({
  name: 'dateFormatLang',
  standalone: true,
})
export class DateFormatLangPipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe
  ) {
  }

  transform(value: any, lang?: string, time:boolean = false): string | null {
    if (!value) return null;

    let date: Date;

    // Handle "dd.MM.yy HH:mm:ss" format
    if (typeof value === 'string' && value.match(/^\d{2}\.\d{2}\.\d{2}\s\d{2}:\d{2}:\d{2}$/)) {
      const [datePart, timePart] = value.split(' ');
      const [day, month, year] = datePart.split('.');
      const [hours, minutes, seconds] = timePart.split(':');

      date = new Date(2000 + parseInt(year), parseInt(month) - 1, parseInt(day),
        parseInt(hours), parseInt(minutes), parseInt(seconds));
    }
    // Handle "YYYY-MM-DD" format (ISO date without time)
    else if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      date = new Date(value + 'T00:00:00');
    }
    // Handle other formats
    else {
      date = new Date(value);
    }

    const f_time = time ? ' HH:mm' : '';
    switch (lang) {
      case 'en-US': {
        return this.datePipe.transform(date, `dd/MM/yyyy${f_time}`);
      }
      default: {
        return this.datePipe.transform(date, `dd.MM.yyyy${f_time}`);
      }
    }
  }
}

